export default {
    name: "SettingsMobileListControls",

    props: {
        searchValue: {
            type: String,
            default: ""
        },
        searchPlaceholder: {
            type: String,
            default: "Search"
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageCount: {
            type: Number,
            default: 1
        },
        paginationLabel: {
            type: String,
            default: "Mobile list pages"
        },
        showSearch: {
            type: Boolean,
            default: true
        },
        showPagination: {
            type: Boolean,
            default: true
        }
    },

    emits: [
        "update:search-value",
        "update:current-page"
    ],

    computed: {
        page_numbers() {
            return Array.from({ length: this.pageCount }, (_, index) => index + 1);
        }
    },

    methods: {
        set_page(page) {
            const next_page = Math.min(Math.max(Number(page), 1), this.pageCount);
            this.$emit("update:current-page", next_page);
        }
    }
};
